import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "src/store";
import { updateTwoFactor } from "src/store/account";
import { makeStyles } from "tss-react/mui";

import { Theme, Typography } from "@mui/material";
import OtpSection from "@shared/otp/OtpSection";
import { SectionPanel } from "@shared/SectionPanel/SectionPanel";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

const useStyles = makeStyles()((theme: Theme) => ({
    descriptionText: {
        marginBottom: theme.spacing(2),
    },
}));

type FormValues = {
    code: string;
};

type TwoFactorDisableFormProps = {
    onSuccess: () => void;
};

export const TwoFactorDisableForm = ({ onSuccess }: TwoFactorDisableFormProps) => {
    const dispatch = useDispatch();
    const { t } = useTranslation(["pages"]);
    const { classes } = useStyles();

    const onSubmit = async ({ code }: FormValues) => {
        try {
            await dispatch(updateTwoFactor({ enabled: false, code })).unwrap();
            showSuccessToast(t("pages:twoFactorDisablePage.toasts.disabled"));
            onSuccess();
        } catch (err) {
            const error = err as Error;
            showErrorToast(error.message);
        }
    };

    return (
        <SectionPanel title={t("pages:twoFactorDisablePage.metaTitle")}>
            <Typography variant="body2" color="text.secondary" className={classes.descriptionText}>
                {t("pages:twoFactorDisablePage.description")}
            </Typography>
            <Form<FormValues>
                onSubmit={onSubmit}
                render={({ handleSubmit, form, submitting }) => (
                    <form onSubmit={(e) => void handleSubmit(e)}>
                        <OtpSection
                            setupOtp
                            submitting={submitting}
                            onSubmit={(otp) => {
                                form.change("code", otp);
                                void handleSubmit();
                            }}
                        />
                    </form>
                )}
            />
        </SectionPanel>
    );
};
